import PackFrontalApi from '../api/packfrontal';

const FETCHING_PACKS = "FETCHING_PACKS",
  FETCHING_PACKS_SUCCESS = "FETCHING_PACKS_SUCCESS",
  FETCHING_PACKS_ERROR = "FETCHING_PACKS_ERROR",
  FETCHING_PACK = "FETCHING_PACK",
  FETCHING_PACK_SUCCESS = "FETCHING_PACK_SUCCESS",
  FETCHING_PACK_ERROR = "FETCHING_PACK_ERROR",
  FETCHING_ELECTROS = "FETCHING_ELECTROS",
  FETCHING_ELECTROS_SUCCESS = "FETCHING_ELECTROS_SUCCESS",
  FETCHING_ELECTROS_ERROR = "FETCHING_ELECTROS_ERROR",
  FETCHING_ELECTRO = "FETCHING_ELECTRO",
  FETCHING_ELECTRO_SUCCESS = "FETCHING_ELECTRO_SUCCESS",
  FETCHING_ELECTRO_ERROR = "FETCHING_ELECTRO_ERROR",
  CREATING_PROJECT = "CREATING_PROJECT",
  CREATING_PROJECT_SUCCESS = "CREATING_PROJECT_SUCCESS",
  CREATING_PROJECT_ERROR = "CREATING_PROJECT_ERROR",
  CREATING_PROJECT_EVENT = "CREATING_PROJECT_EVENT",
  CREATING_PROJECT_EVENT_SUCCESS = "CREATING_PROJECT_EVENT_SUCCESS",
  CREATING_PROJECT_EVENT_ERROR = "CREATING_PROJECT_EVENT_ERROR",
  FETCHING_CUSTOMER = "FETCHING_CUSTOMER",
  FETCHING_CUSTOMER_SUCCESS = "FETCHING_CUSTOMER_SUCCESS",
  FETCHING_CUSTOMER_ERROR = "FETCHING_CUSTOMER_ERROR"
;

export default {
  namespaced: true,
  state: {
    isLoading: false,
    error: null,
    entities: [],
    electros: [],
    selectedEntity: null,
    selectedEntitySizes: [],
    selectedElectro: null,
  },
  getters: {
    isLoading(state) {
      return state.isLoading;
    },
    hasError(state) {
      return state.error !== null;
    },
    error(state) {
      return state.error;
    },
    hasPacks(state) {
      return state.entities.length > 0;
    },
    entities(state) {
      return state.entities;
    },
    entity(state) {
      return state.selectedEntity;
    },
    entitySizes(state) {
      return state.selectedEntitySizes;
    },
    electros(state) {
      return state.electros;
    },
    selectedElectro(state) {
      return state.selectedElectro;
    }
  },
  mutations: {
    [FETCHING_PACKS](state) {
      state.isLoading = true;
      state.error = null;
      state.entities = [];
    },
    [FETCHING_PACKS_SUCCESS](state, data) {
      state.isLoading = false;
      state.error = null;
      state.entities = data;
      state.selectedEntity = null;
    },
    [FETCHING_PACKS_ERROR](state, error) {
      state.isLoading = false;
      state.error = error;
      state.entities = [];
    },
    [FETCHING_PACK](state) {
      state.isLoading = true;
      state.error = null;
      state.selectedEntitySizes = [];
    },
    [FETCHING_PACK_SUCCESS](state, entities) {
      state.error = null;
      state.selectedEntitySizes = entities;
      state.isLoading = false;
    },
    [FETCHING_PACK_ERROR](state, error) {
      state.isLoading = false;
      state.error = error;
      state.selectedEntitySizes = [];
    },
    [FETCHING_ELECTROS](state) {
      state.isLoading = true;
      state.error = null;
    },
    [FETCHING_ELECTROS_SUCCESS](state, electros) {
      state.error = null;
      state.electros = electros;
      state.isLoading = false;
    },
    [FETCHING_ELECTROS_ERROR](state, error) {
      state.isLoading = false;
      state.error = error;
      state.electros = [];
    },
    [FETCHING_ELECTRO](state) {
      state.isLoading = true;
      state.error = null;
    },
    [FETCHING_ELECTRO_SUCCESS](state, electro) {
      state.error = null;
      state.selectedElectro = electro;
      state.isLoading = false;
    },
    [FETCHING_ELECTRO_ERROR](state, error) {
      state.isLoading = false;
      state.error = error;
      state.selectedElectro = null;
    },
    [CREATING_PROJECT](state) {
      state.isLoading = true;
      state.error = null;
    },
    [CREATING_PROJECT_SUCCESS](state, entity) {
      state.isLoading = false;
      state.error = null;
      state.selectedEntity = entity;
    },
    [CREATING_PROJECT_ERROR](state, error) {
      state.isLoading = false;
      state.error = error;
      state.selectedEntity = null;
    },


    [CREATING_PROJECT_EVENT](state) {
      state.isLoading = true;
      state.error = null;
    },
    [CREATING_PROJECT_EVENT_SUCCESS](state, entity) {
      state.isLoading = false;
      state.error = null;
      state.selectedEntity = entity;
    },
    [CREATING_PROJECT_EVENT_ERROR](state, error) {
      state.isLoading = false;
      state.error = error;
      state.selectedEntity = null;
    },
    [FETCHING_CUSTOMER](state) {
      state.isLoading = true;
      state.error = null;
    },
    [FETCHING_CUSTOMER_SUCCESS](state, entity) {
      state.isLoading = false;
      state.error = null;
      state.selectedEntity = entity;
    },
    [FETCHING_CUSTOMER_ERROR](state, error) {
      state.isLoading = false;
      state.error = error;
      state.selectedEntity = null;
    },
  },
  actions: {
    async findAllFrontal({commit}) {
      commit(FETCHING_PACKS);
      try {
        let response = await PackFrontalApi.findAllFrontal();
        commit(FETCHING_PACKS_SUCCESS, response.data);
        return response.data;
      } catch (error) {
        commit(FETCHING_PACKS_ERROR, error);
        return null;
      }
    },
    async findById({commit}, id) {
      commit(FETCHING_PACK);
      try {
        let response = await PackFrontalApi.findById(id);
        commit(FETCHING_PACK_SUCCESS, response.data);
        return response.data;
      } catch (error) {
        commit(FETCHING_PACK_ERROR, error);
        return null;
      }
    },
    async findByCode({commit}, pack_code) {
      commit(FETCHING_PACK);
      try {
        let response = await PackFrontalApi.findByCode(pack_code);
        commit(FETCHING_PACK_SUCCESS, response.data);
        return response.data;
      } catch (error) {
        commit(FETCHING_PACK_ERROR, error);
        return null;
      }
    },
    async getElectros({commit}) {
      commit(FETCHING_ELECTROS);
      try {
        let response = await PackFrontalApi.findAllElectros();
        commit(FETCHING_ELECTROS_SUCCESS, response.data);
        return response.data;
      } catch (error) {
        commit(FETCHING_ELECTROS_ERROR, error);
        return null;
      }
    },
    async getElectro({commit}, sku) {
      commit(FETCHING_ELECTRO);
      try {
        let response = await PackFrontalApi.findElectro(sku);
        commit(FETCHING_ELECTRO_SUCCESS, response.data);
        return response.data;
      } catch (error) {
        commit(FETCHING_ELECTRO_ERROR, error);
        return null;
      }
    },
    async create({commit}, params) {
      commit(CREATING_PROJECT);
      try {
        let response = await PackFrontalApi.createProject(params);
        commit(CREATING_PROJECT_SUCCESS, response.data);
        return response.data;
      } catch (error) {
        commit(CREATING_PROJECT_ERROR, error);
        return null;
      }
    },
    async bookEvent({commit}, params) {
      commit(CREATING_PROJECT_EVENT);
      try {
        let response = await PackFrontalApi.bookEvent(params);
        commit(CREATING_PROJECT_EVENT_SUCCESS, response.data);
        return response.data;
      } catch (error) {
        commit(CREATING_PROJECT_EVENT_ERROR, error);
        return null;
      }
    },
    async getCustomer({commit}, userId) {
      commit(FETCHING_CUSTOMER);
      try {
        let response = await PackFrontalApi.getCustomer(userId);
        commit(FETCHING_CUSTOMER_SUCCESS, response.data);
        return response.data;
      } catch (error) {
        commit(FETCHING_CUSTOMER_ERROR, error);
        return null;
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/packfrontal.js